<template>
  <div v-if="comType == 'UI'">
    <div
      class="coupon-center"
      :style="{
        position: 'relative',
        'border-radius': `${radius}px`,
        margin: `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`,
        padding: `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`,
        overflow: 'hidden',
      }"
    >
      <div
        class="title"
        :style="{
          color: textColor,
          'font-size': `${fontSize}px`,
        }"
      >
        {{ titleText }}
      </div>
      <div>
        <img v-show="imgUrl" :src="imgUrl" draggable="false" />
      </div>
    </div>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <el-form-item label="名称">
          <el-input
            type="text"
            placeholder="请输入名称"
            size="small"
            v-model="titleTextValue"
            maxlength="8"
            show-word-limit
            clearable
            style="width: 180px"
          ></el-input>
        </el-form-item>
        <el-form-item label="字体大小">
          <el-radio-group v-model="fontSizeValue" size="small">
            <el-radio-button :label="12">小</el-radio-button>
            <el-radio-button :label="14">中</el-radio-button>
            <el-radio-button :label="18">大</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="字体颜色">
          <el-color-picker
            v-model="textColorValue"
            :predefine="predefineColors"
            size="small"
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="背景图">
          <customUpload :imageUrl.sync="imgUrlValue"></customUpload>
          <div class="tip">图片宽度限制:750px</div>
        </el-form-item>
      </div>
      <el-divider></el-divider>
      <div>
        <el-form-item label="圆角">
          <div class="slider-block">
            <el-slider v-model="radiusValue" show-input :min="0" :max="50"> </el-slider>
            <div class="set-radius">
              <el-popover placement="top" width="160" trigger="hover">
                <radiusBox :radius="radiusValue"></radiusBox>
                <el-button slot="reference">可见性</el-button>
              </el-popover>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="上间距">
          <div class="slider-block">
            <el-slider v-model="marginTopValue" show-input :min="-100" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="下间距">
          <div class="slider-block">
            <el-slider v-model="marginBottomValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="左间距">
          <div class="slider-block">
            <el-slider v-model="marginLeftValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="右间距">
          <div class="slider-block">
            <el-slider v-model="marginRightValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="上内间距">
          <div class="slider-block">
            <el-slider v-model="paddingTopValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="下内间距">
          <div class="slider-block">
            <el-slider v-model="paddingBottomValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="左内间距">
          <div class="slider-block">
            <el-slider v-model="paddingLeftValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
        <el-form-item label="右内间距">
          <div class="slider-block">
            <el-slider v-model="paddingRightValue" show-input :min="0" :max="100">
            </el-slider>
          </div>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import customUpload from "@/components/appltDecoration/customUpload";
import radiusBox from "@/components/appltDecoration/radiusBox";
import { comMixins } from "@/mixins/comMixins";

export default {
  mixins: [comMixins],
  name: "comCouponCenter",
  components: {
    customUpload,
    radiusBox,
  },
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    imgUrl: {
      type: String,
      default: "",
    },
    marginTop: {
      type: Number,
      default: 10,
    },
    marginRight: {
      type: Number,
      default: 10,
    },
    marginBottom: {
      type: Number,
      default: 10,
    },
    marginLeft: {
      type: Number,
      default: 10,
    },
    paddingTop: {
      type: Number,
      default: 0,
    },
    paddingRight: {
      type: Number,
      default: 0,
    },
    paddingBottom: {
      type: Number,
      default: 0,
    },
    paddingLeft: {
      type: Number,
      default: 0,
    },
    radius: {
      type: Number,
      default: 8,
    },
    textColor: {
      type: String,
      default: "rgb(51, 51, 51)",
    },
    fontSize: {
      type: Number,
      default: 14,
    },
    titleText: {
      type: String,
      default: "领券中心",
    },
  },
  computed: {
    imgUrlValue: {
      get() {
        return this.imgUrl;
      },
      set(val) {
        this.$emit(`update:imgUrl`, val);
      },
    },
    titleTextValue: {
      get() {
        return this.titleText;
      },
      set(val) {
        this.$emit(`update:titleText`, val);
      },
    },
    textColorValue: {
      get() {
        return this.textColor;
      },
      set(val) {
        this.$emit(`update:textColor`, val);
      },
    },
    fontSizeValue: {
      get() {
        return this.fontSize;
      },
      set(val) {
        this.$emit(`update:fontSize`, val);
      },
    },
    radiusValue: {
      get() {
        return this.radius;
      },
      set(val) {
        this.$emit(`update:radius`, val);
      },
    },
    marginTopValue: {
      get() {
        return this.marginTop;
      },
      set(val) {
        this.$emit(`update:marginTop`, val);
      },
    },
    marginRightValue: {
      get() {
        return this.marginRight;
      },
      set(val) {
        this.$emit(`update:marginRight`, val);
      },
    },
    marginBottomValue: {
      get() {
        return this.marginBottom;
      },
      set(val) {
        this.$emit(`update:marginBottom`, val);
      },
    },
    marginLeftValue: {
      get() {
        return this.marginLeft;
      },
      set(val) {
        this.$emit(`update:marginLeft`, val);
      },
    },
    paddingTopValue: {
      get() {
        return this.paddingTop;
      },
      set(val) {
        this.$emit(`update:paddingTop`, val);
      },
    },
    paddingRightValue: {
      get() {
        return this.paddingRight;
      },
      set(val) {
        this.$emit(`update:paddingRight`, val);
      },
    },
    paddingBottomValue: {
      get() {
        return this.paddingBottom;
      },
      set(val) {
        this.$emit(`update:paddingBottom`, val);
      },
    },
    paddingLeftValue: {
      get() {
        return this.paddingLeft;
      },
      set(val) {
        this.$emit(`update:paddingLeft`, val);
      },
    },
  },
};
</script>

<style scoped lang="less">
.coupon-center .title {
  padding-bottom: 5px;
}

.coupon-center img {
  width: 100%;
  height: 78px;
}
</style>
